import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconSpeakerOff$1 = /*@__PURE__*/ proxyCustomElement(class WppIconSpeakerOff extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-speaker-off", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M3.02427 2.17568C2.78996 1.94136 2.41006 1.94136 2.17574 2.17567C1.94142 2.40998 1.94142 2.78988 2.17573 3.0242L5.55025 6.39879H3.8C2.80589 6.39879 2 7.20467 2 8.19879V11.7971C2 12.7912 2.80589 13.5971 3.8 13.5971H6.74365C6.89063 13.5971 7.0325 13.6511 7.14234 13.7487L10.7355 16.9437C11.3804 17.5171 12.4 17.0593 12.4 16.1964V13.2487L16.9755 17.8243C17.2099 18.0586 17.5898 18.0586 17.8241 17.8243C18.0584 17.59 18.0584 17.2101 17.8241 16.9758L3.02427 2.17568ZM11.2 12.0486V15.7509L7.93972 12.852C7.6102 12.559 7.18459 12.3971 6.74365 12.3971H3.8C3.46863 12.3971 3.2 12.1285 3.2 11.7971V8.19879C3.2 7.86741 3.46863 7.59879 3.8 7.59879H6.74369C6.74586 7.59879 6.74804 7.59878 6.75022 7.59877L11.2 12.0486ZM11.2 4.24535V8.65447L12.4 9.85449V3.79992C12.4 2.93703 11.3804 2.47924 10.7356 3.05258L8.01602 5.47044L8.866 6.32043L11.2 4.24535ZM14.1128 11.5673L15.0232 12.4778C15.3926 11.7302 15.6 10.8885 15.6 9.99992C15.6 9.03737 15.3566 8.12988 14.9276 7.33739C14.7699 7.04598 14.4058 6.93763 14.1144 7.09538C13.8229 7.25313 13.7146 7.61725 13.8723 7.90866C14.2087 8.53008 14.4 9.24177 14.4 9.99992C14.4 10.5528 14.2983 11.0809 14.1128 11.5673ZM15.9105 13.365L16.7852 14.2398C17.5549 13.0104 18 11.5565 18 9.99993C18 8.21904 17.4174 6.57248 16.4325 5.24282C16.2353 4.97653 15.8595 4.92055 15.5933 5.11778C15.327 5.31501 15.271 5.69076 15.4682 5.95705C16.3052 7.08709 16.8 8.48485 16.8 9.99993C16.8 11.2248 16.4766 12.373 15.9105 13.365Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-speaker-off-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-speaker-off", "wpp-icon-speaker-off-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-speaker-off-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-speaker-off-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconSpeakerOff$1);
      }
      break;
  } });
}

const WppIconSpeakerOff = WppIconSpeakerOff$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconSpeakerOff, defineCustomElement };
